<template>
  <div>
    <div class="header">
      <img
        v-if="state.status === 2"
        class="img1"
        referrerpolicy="no-referrer"
        src="/icon/reg/wait.png"
      />
      <img
        v-else
        class="pic1"
        referrerpolicy="no-referrer"
        src="/icon/reg/reject.png"
      />
      <div class="wrap1">
        <span v-if="state.status === 2" class="word3">已完成资料的提交</span>
        <span class="word3" v-if="state.status === 4">审核未通过</span>
        <span class="word4" v-if="state.status === 2"
          >请耐心等待后台审核，您会在审核通过和不通过时，收到对应的短信通知。</span
        >
        <span class="word4" v-if="state.status === 4"
          >您的申请未通过审核，请查看具体原因。您可以返回修改后重新提交审核。</span
        >
      </div>
    </div>
    <div class="main2"></div>
    <!-- 待审核状态 -->
    <div class="mod1" v-if="state.status === 2">
      <h3>以下是您的申请信息</h3>
      <!-- 个人 -->
      <div class="personStaypass" v-if="state.institutionType === 2">
        <div class="msg">
          <span class="keyname">账号名</span
          ><span class="message">{{ state.accountName }}</span>
        </div>
        <div class="msg">
          <span class="keyname">姓名&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.username }}</span>
        </div>
        <div class="msg">
          <span class="keyname">手机&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.mobile }}</span>
        </div>
      </div>
      <!-- 课程方 -->
      <div class="institutionStaypass" v-if="state.institutionType === 1">
        <div class="msg">
          <span class="keyname">账号名</span
          ><span class="message">{{ state.accountName }}</span>
        </div>
        <div class="msg">
          <span class="keyname">课程方名</span
          ><span class="message" style="margin-left: 37px">{{
            state.institutionName
          }}</span>
        </div>
        <div class="msg">
          <span class="keyname">负责人</span
          ><span class="message">{{ state.username }}</span>
        </div>
        <div class="msg">
          <span class="keyname">手机&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.mobile }}</span>
        </div>
      </div>
      <!-- 高校与协会 -->
      <div class="institutionStaypass" v-if="state.institutionType === 3">
        <div class="msg">
          <span class="keyname"
            >账号名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.accountName }}</span>
        </div>
        <div class="msg">
          <span class="keyname">高校与协会名称</span
          ><span class="message" style="margin-left: 37px">{{
            state.institutionName
          }}</span>
        </div>
        <div class="msg">
          <span class="keyname">联系人姓名&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.username }}</span>
        </div>
        <div class="msg">
          <span class="keyname">联系人手机号</span
          ><span class="message">{{ state.mobile }}</span>
        </div>
      </div>
    </div>
    <!-- 审核不通过状态 -->
    <div class="mod2" v-if="state.status === 4">
      <h3>审核不通过详情</h3>
      <!-- 个人 -->
      <div class="personNopass" v-if="state.institutionType === 2">
        <div class="msg">
          <span class="keyname">不通过原因</span
          ><span class="message">{{ state.failReason }}</span>
        </div>
        <h3 style="margin-top: 32px">以下是您的申请信息</h3>
        <div class="msg">
          <span class="keyname">账号名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.accountName }}</span>
        </div>
        <div class="msg">
          <span class="keyname"
            >姓名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.username }}</span>
        </div>
        <div class="msg">
          <span class="keyname"
            >手机&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.mobile }}</span>
        </div>
      </div>
      <!-- 课程方 -->
      <div class="institutionNopass" v-if="state.institutionType === 1">
        <div class="msg">
          <span class="keyname">不通过原因</span
          ><span class="message">{{ state.failReason }}</span>
        </div>
        <h3 style="margin-top: 32px">以下是您的申请信息</h3>
        <div class="msg">
          <span class="keyname">账号名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.accountName }}</span>
        </div>
        <div class="msg">
          <span class="keyname">课程方名&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.institutionName }}</span>
        </div>
        <div class="msg">
          <span class="keyname">负责人&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.username }}</span>
        </div>
        <div class="msg">
          <span class="keyname"
            >手机&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.mobile }}</span>
        </div>
      </div>
      <!-- 高校与协会 -->
      <div class="institutionNopass" v-if="state.institutionType === 3">
        <div class="msg">
          <span class="keyname"
            >不通过原因&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.failReason }}</span>
        </div>
        <h3 style="margin-top: 32px">以下是您的申请信息</h3>
        <div class="msg">
          <span class="keyname"
            >账号名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.accountName }}</span>
        </div>
        <div class="msg">
          <span class="keyname">高校与协会名称</span
          ><span class="message">{{ state.institutionName }}</span>
        </div>
        <div class="msg">
          <span class="keyname"
            >联系人姓名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.username }}</span>
        </div>
        <div class="msg">
          <span class="keyname">联系人手机号&nbsp;&nbsp;&nbsp;</span
          ><span class="message">{{ state.mobile }}</span>
        </div>
      </div>
      <div class="changeButton">
        <a-button type="primary" @click="returnCorrection">返回修改</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import user from '../../../api/user'
export default {
  data() {
    return {
      state: {},
    }
  },
  created() {
    this.getUserAuditResult()
  },
  methods: {
    async getUserAuditResult() {
      await user
        .getInformation()
        .then((res) => {
          console.log('state', this.state)
          console.log('res', res)
          this.state = res.data
          this.$store.commit('register/changeInformation', res.data)
          console.log('this.$store', this.$store.state.register.form)
        })
        .catch((e) => {
          console.log('e', e)
        })
    },
    //返回修改
    returnCorrection() {
      this.$emit('lastStep', 1)
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  margin: 13px 0 0 6px;
}
.pic1 {
  z-index: 23;
  width: 50px;
  height: 50px;
}
.wrap1 {
  display: inline-block;
  height: 50px;
  vertical-align: middle;
  margin-left: 23px;
  .word3 {
    display: block;
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-family: PingFangSC-Semibold;
  }
  .word4 {
    color: rgba(135, 136, 138, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    margin-top: 8px;
  }
}
.main2 {
  z-index: 12;
  width: 100%;
  height: 4px;
  background-color: rgba(235, 241, 253, 1);
  align-self: flex-end;
  margin-top: 37px;
}
.mod1 {
  margin-left: 63px;
  margin-top: 30px;
  margin-bottom: 200px;
  h3 {
    margin-bottom: 16px;
  }
  .personStaypass {
    .msg {
      margin-bottom: 11px;
      .keyname {
        width: 92px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #87888a;
      }
    }
    .message {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      margin-left: 52px;
    }
  }
  .institutionStaypass {
    .msg {
      margin-bottom: 11px;
      .keyname {
        width: 92px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #87888a;
      }
    }
    .message {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      margin-left: 52px;
    }
  }
}
.mod2 {
  margin-left: 63px;
  margin-top: 30px;
  margin-bottom: 50px;
  h3 {
    margin-bottom: 16px;
  }
  .personNopass {
    .msg {
      margin-bottom: 11px;
      .keyname {
        width: 92px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #87888a;
      }
      .message {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        margin-left: 52px;
      }
    }
  }
  .institutionNopass {
    .msg {
      margin-bottom: 11px;
      .keyname {
        width: 92px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: #87888a;
      }
      .message {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        margin-left: 52px;
      }
    }
  }
  .changeButton {
    margin-top: 25px;
    .ant-btn {
      width: 102px;
      height: 42px;
    }
  }
}
</style>
